<!-- eslint-disable -->
<template>
	<div class="d-flex flex-column text-12 text-gotham-medium m-width text-14 w-50 m-auto">
		<div class="pt-16 flex-col space-y-4 p-4" style="flex-direction: column;"> 
			<button type="button" @click="backToUAFunc()" class="button rounded-lg py-3 px-6  text-gotham-bold mb-4" style="width: 100%;background-color:#5F51A1;color:white;border:1px solid #5F51A1;">closePaxelWebview</button>
			<button type="button" @click="copy_to_clipboardFunc('text copied')" class="button rounded-lg py-3 px-6  text-gotham-bold mb-4" style="width: 100%;background-color:#5F51A1;color:white;border:1px solid #5F51A1;">copyClipboard</button>
			<button type="button" @click="buttonSyncCopyClipboard('text copied 2')" class="button rounded-lg py-3 px-6  text-gotham-bold mb-4" style="width: 100%;background-color:#5F51A1;color:white;border:1px solid #5F51A1;">buttonSyncCopyClipboard (experiment)</button>
			<button type="button" @click="openGmapLinkFunc()" class="button rounded-lg py-3 px-6  text-gotham-bold mb-4" style="width: 100%;background-color:#5F51A1;color:white;border:1px solid #5F51A1;">openGmapLink</button>
			<button type="button" @click="openGmapLocationFunc()" class="button rounded-lg py-3 px-6  text-gotham-bold mb-4" style="width: 100%;background-color:#5F51A1;color:white;border:1px solid #5F51A1;">openGmapLocation</button>
			<button type="button" @click="shareOrderFunc()" class="button rounded-lg py-3 px-6  text-gotham-bold mb-4" style="width: 100%;background-color:#5F51A1;color:white;border:1px solid #5F51A1;">shareOrder</button>
		</div>

	</div>
</template>
<script>
/* eslint-disable */


export default {
	mounted (){
		window.backToUA = this.backToUAFunc
		window.copy_to_clipboard = this.copy_to_clipboard
		window.openGmapLink = this.openGmapLink
		window.openGmapLocation = this.openGmapLocation
		window.shareOrder = this.shareOrder2
	},
	methods : {
		backToUAFunc() {
			this.buttonSyncBackToUA();
		},
		copy_to_clipboardFunc(text) {
			this.buttonSyncCopyClipboard(text);
		},
		openGmapLinkFunc() {
			let mapLink = "https://maps.app.goo.gl/x6wYhEL27hBaSDtK8"
			this.buttonSyncOpenGmapLink(mapLink);
		},
		openGmapLocationFunc() {
			let lat = -6.223133
			let long = 106.868275
			this.buttonSyncOpenGmapLocation(lat, long);
		},
		shareOrderFunc(){
			let language = "en"
			let sampleData = {
				recipientName : "John Doe",
				expressNumber : "EM0SD7U2KCOW61720509414",
				box : {
					address : "Jln Surya Sumantri Bandung",
					name: "Paxelbox 2024 Bandung",
				},
				paymentInfo :[],
				status :"Sewa selesai"
			}
			
			let order_calculation_detail = [
      {
        "value" : this.formatRupiah(11000),
        "label" : language == 'en'?'Biaya Sewa':'Rent Fee',
        "key" : "payOfAmount",
        "style" : ""
      },
      {
        "value" : this.formatRupiah(500),
        "label" : "1 item | Donasi 02",
        "key" : "donation",
        "style" : ""
      },
      {
        "value" : this.formatRupiah(1000),
        "label" : "1 item | DONASI YUK",
        "key" : "donation",
        "style" : ""
      },
      {
        "value" : this.formatRupiah(500),
        "label" : language == 'en'?'Admin Fee':'Biaya Admin',
        "key" : "adminFee",
        "style" : ""
      },
      {
        "value" : this.formatRupiah(13000),
				"label" : language == 'en'?'Total Payment':'Total Pembayaran',
        "key" : "totalPayment",
        "style" : "bold"
      },
      {
        "value" : "gopay",
				"label" : language == 'en'?'Payment Method':'Metode Pembayaran',
        "key" : "paymentMethod",
        "style" : ""
      }
    ]
		sampleData.paymentInfo = order_calculation_detail
		console.log((sampleData))
		console.log(JSON.stringify(sampleData))
		this.buttonSyncShareOrder(sampleData)
		},
	}
};

</script>